import React from 'react'

import { Helmet } from 'react-helmet'

import './games.css'

const Games = (props) => {
  return (
    <div className="games-container">
      <Helmet>
        <title>Games - AbApps</title>
        <meta property="og:title" content="Games - AbApps" />
      </Helmet>
      <div className="games-hero hero-container section-container">
        <div className="games-container01">
          <h1 className="games-text">
            <span>Among Us </span>
            <br></br>
          </h1>
          <a
            href="https://among-us-online-fan-remake.1tim.repl.co/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container02">
          <h1 className="games-text03">
            <span>Mario 64 </span>
            <br></br>
          </h1>
          <a
            href="https://28klotlucas2.github.io/Mario64webgl/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link01 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container03">
          <h1 className="games-text06">
            <span>Run 3 </span>
            <br></br>
          </h1>
          <a
            href="https://lekug.github.io/tn6pS9dCf37xAhkJv/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link02 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container04">
          <h1 className="games-text09">Crossy Road </h1>
          <a
            href="https://www-sites-opensocial.googleusercontent.com/gadgets/ifr?url=https://sites.google.com/site/s011h5fk/crossy-road.xml"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link03 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container05">
          <h1 className="games-text10">Minecraft </h1>
          <a
            href="https://precisionclient.vercel.app/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link04 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container06">
          <h1 className="games-text11">G.B.A. </h1>
          <a
            href="https://guzuv.github.io/guzEmu/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link05 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container07">
          <h1 className="games-text12">
            <span>Sword Battle.io </span>
            <br></br>
          </h1>
          <a
            href="https://sword-io-game.herokuapp.com/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link06 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
        <div className="games-container08">
          <h1 className="games-text15">
            <span>1v1.lol  </span>
            <br></br>
          </h1>
          <a
            href="https://1v1lol.56306.repl.co/"
            target="_blank"
            rel="noreferrer noopener"
            className="games-link07 button button-gradient"
          >
            CLICK HERE
          </a>
        </div>
      </div>
      <div className="games-container09">
        <h1 className="games-text18">
          <span>Mario 64 </span>
          <br></br>
        </h1>
        <a
          href="https://28klotlucas2.github.io/Mario64webgl/"
          target="_blank"
          rel="noreferrer noopener"
          className="games-link08 button button-gradient"
        >
          CLICK HERE
        </a>
      </div>
      <div className="games-container10">
        <h1 className="games-text21">
          <span>Smash Karts</span>
          <br></br>
          <span>thanks to guzuv.ml</span>
          <br></br>
        </h1>
        <a
          href="https://images-opensocial.googleusercontent.com/gadgets/ifr?url=https://cdn.jsdelivr.net/gh/zhit73/8y3ds26tf3s@main/sc51di7fwus3.xml"
          target="_blank"
          rel="noreferrer noopener"
          className="games-link09 button button-gradient"
        >
          CLICK HERE
        </a>
      </div>
    </div>
  )
}

export default Games
